import React from 'react';
import './BlogCard.css';
import { Link } from 'react-router-dom';

export default function BlogCard(props) {   
    const imgUrl = props.img == null 
    ? "https://openclipart.org/image/2400px/svg_to_png/211479/Simple-Image-Not-Found-Icon.png" 
    :props.img;
    
    return (  
      <div className="blog-card" style={{backgroundColor:props.color}}>
        <img
          src={imgUrl}
          alt="blog card"
        />
        <div className="blog-card-content">
          <h2 className="blog-card-name">
            <Link to={props.link}> 
              {props.title}
            </Link>
          </h2>
          <div className="blog-card-description">
            {props.description}
          </div>
        </div>
      </div> 
    )
}